import http from '@/biz/http.mjs'

export default {

    create: (data) => http.post('/imlsis', data),

    publish: (data) => http.put(
        '/imlsis/rlsandrevise',
        {...data, stsCode: 'RLS'}
    ),

    pull: ({pkid}) => http.get(`/imlsis/${pkid}/dps`),
    push: (data) => http.post('/imlsis/batchmodify', data),
    read: ({pkid}) => http.get(`/imlsis/${pkid}`),
    readList: (args) => http.get('/imlsis', args),

    revise: ({pkid}) => http.put(
        '/imlsis/rlsandrevise',
        {pkid, stsCode: 'REVISE'}
    ),

    update: (data) => http.put(`/imlsis/${data.pkid}`, data),
    updateMap: (data) => http.put(`/imlsis/${data.pkid}/map`, data),
}
